export enum VersionSupportStatus {
  AppStoreUpgrade = 'APP_STORE_UPGRADE',
  OverTheAirUpgrade = 'OVER_THE_AIR_UPGRADE',
  Supported = 'SUPPORTED',
}

export interface MinimumVersionData {
  appMinimumVersion: string | null;
  supportStatus: VersionSupportStatus;
}
